import React from 'react';
import PropTypes from 'prop-types';
import {
    Checkbox,
    MenuItem,
    FormControl,
    ListItemText,
    Select,
    InputLabel
} from '@mui/material';

export default class MultiSelect extends React.Component {
    handleToggle = (id) => {
        const { value, onChange } = this.props;
        const selected = value || [];
        const isSelected = selected.includes(id);

        const newValue = isSelected
            ? selected.filter((v) => v !== id)
            : [...selected, id];

        onChange(newValue);
    };

    render() {
        const { id, label, items, value, placeholder } = this.props;

        const renderValue = (selected) => {
            if (!selected || selected.length === 0) {
                return placeholder || 'Nothing selected';
            }
            return selected
                .map((val) => {
                    const found = items.find((i) => i.id === val);
                    return found ? found.label : val;
                })
                .join(', ');
        };

        return (
            <FormControl fullWidth sx={{ marginY: 1 }}>
                <InputLabel id={`${id}-label`}>{label}</InputLabel>
                <Select
                    id={id}
                    labelId={`${id}-label`}
                    label={label}
                    multiple
                    value={value}
                    renderValue={renderValue}
                    MenuProps={{
                        PaperProps: {
                            style: { maxHeight: 200 }
                        }
                    }}
                >
                    {items.map((item) => (
                        <MenuItem
                            key={item.id}
                            value={item.id}
                            onClick={() => this.handleToggle(item.id)}
                        >
                            <Checkbox checked={value.includes(item.id)} />
                            <ListItemText primary={item.label} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }
}

MultiSelect.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string
};

MultiSelect.defaultProps = {
    value: [],
    placeholder: ''
};
